module.exports = __webpack_public_path__ + "img/banner-2.2b685f69.png";